import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Image from "gatsby-image";

const LogoNav = ({ textAlt }) => {
  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "portada-transparente-blanco.png" }) {
        childImageSharp {
          fixed(width: 53, height: 38) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `);
  const textAlternative = textAlt ? textAlt : "INICIO";

  const imagFile = data.file;
  return (
    <>
      {data.file && (
        <Image fixed={imagFile.childImageSharp.fixed} alt={textAlternative} />
      )}
    </>
  );
};

export default LogoNav;
